import React from 'react';

export type Size = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'span';

const sizeClasses: Record<Size, string> = {
  h1: 't3xl-mobile md:text-3xl font-bold',
  h2: 't2xl-mobile md:text-2xl font-bold',
  h3: 'txl-mobile md:text-xl font-bold',
  h4: 'txl-mobile md:text-xl font-bold',
  h5: 'tlg-mobile md:text-lg',
  p: 'tsm-mobile md:text-sm',
  span: 'tsm-mobile md:text-sm',
};

export interface TitleHeadingProps {
  label: string | number;
  size: Size;
  htmlFor?: string;
  required?: boolean;
  className?: string;
  icon?: IconProps;
}

export interface IconProps {
  fa: string;
  color: string;
}

const TitleHeading: React.FC<TitleHeadingProps> = ({
  htmlFor,
  label,
  size,
  required = false,
  className,
  icon
}) => {
  const classes: string = (sizeClasses[size] + ' text-blue-950 break-word ' + className).trim();


  return <div
    {...(htmlFor ? { htmlFor } : {})}
    className={classes}
  >
    {icon && <i className={`${icon.fa} ${icon.color} mr-1`}></i>}
    <span dangerouslySetInnerHTML={{ __html: label }} />
    {required && <span className="text-red-500 ml-1">*</span>}
  </div>
};

export default TitleHeading;